
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/sandbox",
      function () {
        return require("private-next-pages/docs/transfer/sandbox.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/sandbox"])
      });
    }
  